import { render } from "./manage_promotions.vue?vue&type=template&id=75fb371a"
import script from "./manage_promotions.vue?vue&type=script&lang=js"
export * from "./manage_promotions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__